import Vue from "vue";

import auth from "@websanova/vue-auth/dist/v2/vue-auth.common.js";
import driverAuthBearer from "@websanova/vue-auth/dist/drivers/auth/bearer.js";
import driverHttpVueResource from "@websanova/vue-auth/dist/drivers/http/vue-resource.1.x.js";
import driverRouterVueRouter from "@websanova/vue-auth/dist/drivers/router/vue-router.2.x.js";

Vue.use(auth, {
  plugins: {
    http: Vue.http,
    router: Vue.router,
  },
  drivers: {
    auth: driverAuthBearer,
    http: driverHttpVueResource,
    router: driverRouterVueRouter,
  },
  options: {
    authRedirect: (transition) => {
      let redirect = transition.fullPath;

      if (redirect === "/jobs") {
        return { path: "/login" };
      }

      // Prevent double encoding/escaping
      if (redirect.includes("%")) {
        redirect = decodeURIComponent(redirect);
      }
      redirect = encodeURIComponent(redirect);

      return {
        path: `/login?redirect=${redirect}`,
      };
    },
    refreshData: {
      enabled: false,
    },
    rolesKey: "role",
    forbiddenRedirect: "/error/403",
    notFoundRedirect: "/error/404",
  },
});
